import { RootState } from '../../model/model'

export const couvetteVideoSelector = (state: RootState) => state.couvetteVideo

export const couvetteVideoIdSelector = (state: RootState) => state.couvetteVideo.mediaUniqueId
